/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import VirtualAgentSettingsPageQuery from './__generated__/VirtualAgentSettingsPageQuery$parameters';
import type { VirtualAgentSettingsPageQuery as VirtualAgentSettingsPageQueryType } from './__generated__/VirtualAgentSettingsPageQuery.graphql';

type SettingsEntryPointComponent = EntryPointComponent<
	{
		page: VirtualAgentSettingsPageQueryType;
	},
	{},
	{},
	{} | null
>;

export const settingsEntryPoint: EntryPoint<SettingsEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<SettingsEntryPointComponent>(
			/* webpackChunkName: "async-virtual-agent-settings" */ './VirtualAgentSettingsPage.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
			queries: {
				page: {
					parameters: VirtualAgentSettingsPageQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
					},
				},
			},
		}),
	});
